// extracted by mini-css-extract-plugin
export default {"grid":"CardList_grid__-NsFg","flexGrid":"CardList_flexGrid__8V1GY","flexColumn":"CardList_flexColumn__-+Y56"};